module.exports = __webpack_public_path__ + "static/img/Value-right-Arrows.ac44945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/Value-right-Arrows.png
// module id = qY/N
// module chunks = 1